import {Badge} from "@mantine/core"
import {
    User,
    UserStatus
} from "../types";


const STATUS_CONFIG = {
    [UserStatus.CONFIRMED]: {
        color: 'green',
        label: 'Confirmed'
    },
    [UserStatus.RESET_REQUIRED]: {
        color: 'yellow',
        label: 'Reset Required'
    },
    [UserStatus.EXTERNAL_PROVIDER]: {
        color: 'blue',
        label: 'External Provider'
    },
    [UserStatus.UNCONFIRMED]: {
        color: 'orange',
        label: 'Unconfirmed'
    },
    [UserStatus.FORCE_CHANGE_PASSWORD]: {
        color: 'violet',
        label: 'Password Change Required'
    }
} as const;

export const UserStatusBadge = ({record}: { record: User }) => {

    if (!record?.status) {
        return <Badge color='dark'>Invalid Status</Badge>;
    }

    const config = STATUS_CONFIG[record.status as UserStatus];
    return <Badge color={config.color}>{config.label}</Badge>;

}